<template>
  <div id="one-click-order">
    <div>
      <cart-side />
    </div>
    <div id="header-info">
      <div class="topbar">
        <topbar />
      </div>
      <div>
        <search :words="searchKeyWords" @searchByKeWords="searchByKeWords" @clearWords="clearWords" @search="search" @searchList="searchList" />
      </div>
    </div>
    <div>
      <app-nav />
    </div>
    <div id="about-goods">
      <div id="header">
        <b-container class="bv-example-row">
          <b-row>
            <b-col v-for="(select,index) in selected" :key="index">
              {{ select.text }}:
              <div class="select-text">
                <b-dropdown :text="select.showSelect.desc" :title="select.showSelect.desc" max-width="10" :disabled="select.disabled" variant="outline-danger" class="m-1">
                  <b-dropdown-item
                    v-for="(shop,indexs) in select.selectArray"
                    :key="indexs"
                    @click="choose(select.label,shop)"
                  >{{ shop.desc }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div id="sort-by">
        <div class="sort">
          排序依据:
          <div class="select-text">
            <b-dropdown :text="sortBy.sorttext" variant="outline-danger" class="m-1">
              <b-dropdown-item
                v-for="(sort,index) in sortText"
                :key="index"
                @click="choose('sort',sort)"
              >{{ sort.text }}</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="is-in-stock">
          只看有货
          <span class="select" :class="{'selected':!check}" @click="isInventory" />
        </div>
      </div>
      <div id="content">
        <b-table :items="itemList" :fields="fields" responsive>
          <template v-slot:cell(name)="data">
            <span v-if="data.item.promotionType === 1" v-b-tooltip.html class="active-type" :title="data.item.promotion">赠</span>
            <span v-if="data.item.promotionType === 2" v-b-tooltip.html class="active-type" :title="data.item.promotion">特</span>
            <a href="javascript:void(0)" @click="goto(data.item.id)">
              {{ data.item.commonName }}<br>{{ data.item.name }}
            </a>
          </template>
          <template v-slot:cell(image)="data">
            <a href="javascript:void(0)" @click="goto(data.item.id)">
              <img :src="data.value" alt="">
            </a>
          </template>
          <template v-slot:cell(showPrice)="data">
            <span v-if="data.item.promotionType === 2" class="active-type">特</span>
            {{ data.item.showPrice }}
          </template>
          <template v-slot:cell(num)="data">
            <div class="item-number">
              <span class="cutdown" @click="cutdown(data.index)">-</span>
              <input v-model="data.value" :disabled="data.item.disabled" class="num" @blur="change(data.value,data.index)">
              <span class="add" @click="add(data.index)">+</span>
            </div>
          </template>
          <template v-slot:cell(operate)="data">
            <b-button variant="danger" @click="addToCart(data)">加入</b-button>
          </template>
        </b-table>
      </div>
      <div>
        <page-info :page-info="pageInfo" @searchFirst="changePage" />
      </div>
    </div>
    <div>
      <app-footer />
    </div>
  </div>
</template>
<script>
import footer from '@/components/Footer.vue'
import topbar from '@/components/TopBar.vue'
import search from '@/components/Search.vue'
import PageInfo from '@/components/Pagination.vue'
import nav from '@/components/Nav.vue'
import { ItemService } from '@/service/ItemService'
import CartSide from './CartSide'
export default {
  components: {
    'cart-side': CartSide, 'app-nav': nav, 'page-info': PageInfo,
    search, topbar, 'app-footer': footer
  },
  data () {
    return {
      startTime: '',
      searchText: '',
      searchKeyWords: [],
      selected: [
        { text: '供应商', label: 'shop', showSelect: { desc: '全部', search: -1 }, selectArray: [{ desc: '全部', search: -1 }], disabled: true },
        { text: '生产厂家', label: 'manufacture', showSelect: { desc: '全部', search: '' }, selectArray: [{ desc: '全部', search: '' }], disabled: true },
        { text: '规格', label: 'norm', showSelect: { desc: '全部', search: '' }, selectArray: [{ desc: '全部', search: '' }], disabled: true },
        { text: '区域', label: 'region', showSelect: { desc: '全部', search: -1 }, selectArray: [{ desc: '全部', search: -1 }], disabled: true }
      ],
      fields: [
        { key: 'image', label: '图片' }, { key: 'name', label: '通用名/商品名' },
        { key: 'norm', label: '规格' }, { key: 'manufacturer', label: '生产厂家' },
        { key: 'licenseNumber', label: '批准文号' }, { key: 'shopName', label: '供应商' },
        { key: 'largeScale', label: '大包装' }, { key: 'basicUnit', label: '单位' },
        { key: 'inventory', label: '库存' }, { key: 'expiryTime', label: '有效期至' },
        { key: 'oldPrice', label: '配送价' }, { key: 'showPrice', label: '调拨价' },
        { key: 'num', label: '数量' }, { key: 'operate', label: '订购' }
      ],
      check: true,
      sortBy: { sorttext: '默认', sort: 'createTime desc' },
      sortText: [{ text: '默认', sort: 'createTime desc' },
        { text: '参考价升序', sort: 'calcuPrice asc' },
        { text: '参考价降序', sort: 'calcuPrice desc' },
        { text: '库存', sort: 'inventory desc' },
        { text: '销售额', sort: 'product(salesVolume,transferPrice) desc' },
        { text: '销量', sort: 'salesVolume desc' }],
      pageInfo: { count: '', index: 1, pages: '', size: 10 },
      itemList: [],
      queryHasInventory: -1,
      showshopName: { shopText: '全部', shopId: -1 },
      manuToSearch: { manuText: '全部', search: '' },
      normToSearch: { normText: '全部', search: '' },
      regionToSearch: { regionText: '全部', unionId: -1 }
    }
  },
  computed: {
    isSearch: function () {
      let result = true
      if (this.searchText.length >= 2) {
        result = false
      }
      return result
    }
  },
  beforeRouteEnter (to, from, next) {
    const shopId = to.params.maker

    console.log(shopId, '供应商')
    next(vm => {
      vm.searchFirst(shopId)
    })
  },
  watch: {

  },
  mounted () {
    document.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.initialData()
  },
  methods: {
    clearWords () {
      this.searchKeyWords = []
    },
    searchByKeWords (word) {
      this.searchText = word
      this.searchKeyWords = []
    },
    goto (itemId) {
      this.$store.commit('addVisitedItem', itemId)
      this.$store.getters.getVisitedItems
      console.log(this.$store.getters.getVisitedItems, 'itemIds')
      const router = this.$router.resolve({
        name: 'item',
        query: { id: itemId }
      })
      const path = process.env.BASE_URL + `index.html#item?id=${itemId}`
      console.log(path, router, 'router', 'url')
      window.open(path, '_blank')
    },
    searchList (str) {
      const data = {
        search: str,
        shopId: -1,
        queryHasInventory: -1,
        unionId: -1,
        manufacturer: this.manuToSearch.search
      }
      const url = '/hy-sb-item/item/pageSearchAllItems'
      this.$axios.post(url, data).then((response) => {
        if (response.code === '0') {
          const { content: { list = [] }} = response
          this.putToSearchList(list)
        }
      })
      console.log(str, 'strlist')
    },
    changePage (pageInfo) {
      this.pageInfo = pageInfo
      this.searchFirst()
    },
    putToSearchList (items) {
      var searchList = []
      items.forEach(item => {
        searchList.push(item.name)
      })
      console.log(searchList, 'searchList')
      this.searchKeyWords = searchList
    },
    change (value, num) {
      this.itemList[num].num = Number(value)
      console.log(value, num, this.itemList[num])
    },
    add (num) {
      if (!this.itemList[num].disabled) {
        this.itemList[num].num++
      }
    },
    cutdown (num) {
      if (this.itemList[num].num !== 1) {
        this.itemList[num].num--
      }
    },
    showToast (str) {
      this.$bvToast.toast(str, {
        title: '加入购物车',
        autoHideDelay: 2000
      })
    },
    dealItemNum (count, inventory) {
      console.log(count, inventory, 'inventory count')
      // 购物车数量为0或超出库存时
      let result = 1
      if (inventory === 0 || count > inventory) {
        result = inventory === 0 ? -1 : 2
      }
      return result
    },
    dealAddNum (item) {
      const itemCart = this.$store.getters.getItemById(item.id)
      if (itemCart.length !== 0 && itemCart[0].num > 0) {
        if (itemCart[0].num >= item.inventory) {
          this.showToast('库存不足')
          return -1
        } else {
          var num = itemCart[0].num + item.num
          num = num < item.inventory ? num : item.inventory
          return num
        }
      } else {
        return item.num < item.inventory ? item.num : item.inventory
      }
    },
    addToCart (data) {
      const item = data.item
      const price = Number(item.showPrice) === 0 ? item.oldPrice : item.showPrice
      if (isNaN(price) || Number(price) === 0) {
        this.showToast('价格错误')
        return
      } else {
        const result = this.dealItemNum(item.num, item.inventory)
        if (result === 2 || result === 1) {
          if (this.dealAddNum(item) !== -1) {
            item.num = this.dealAddNum(item)
            const tmpItem = { price: price };
            ({ id: tmpItem.id, num: tmpItem.num, image: tmpItem.image, shopId: tmpItem.shopId, shopName: tmpItem.shopName,
              norm: tmpItem.norm, commonName: tmpItem.name, manufacturer: tmpItem.manufacture } = item)
            console.log(tmpItem, 'tmpItem')
            this.$store.commit('addTocart', tmpItem)
            this.showToast(`加入购物车成功`)
            item.num = 1
            return
          } else {
            item.num = 1
            return
          }
        } else {
          item.num = 1
          return
        }
      }
    },
    isInventory () {
      if (this.check) {
        this.queryHasInventory = 1
        this.check = false
      } else {
        this.queryHasInventory = -1
        this.check = true
      }
      this.pageInfo.index = 1
      this.searchFirst()
      console.log(this.check, this.queryHasInventory, 'querty', 'check')
    },
    searchFirst (shopId) {
      if (shopId !== undefined) {
        this.showshopName.shopId = shopId
      }
      console.log(this.searchText, 'searchText')
      const data = {
        search: this.searchText,
        index: this.pageInfo.index,
        size: this.pageInfo.size,
        orderBy: this.sortBy.sort,
        shopId: this.showshopName.shopId,
        manufacturer: this.manuToSearch.search,
        title2: this.normToSearch.search,
        queryHasInventory: this.queryHasInventory,
        unionId: this.regionToSearch.unionId
      }
      const Item = new ItemService(this.$axios)
      Item.loadItems(data).then(response => {
        this.dealItems(response)
      })
    },
    search (str) {
      this.searchKeyWords = []
      this.searchText = str
      this.pageInfo.index = 1
      const Item = new ItemService(this.$axios)
      if (str.length >= 2) {
        this.searchFirst()
        Item.loadManufature(str).then(response => {
          this.dealSelect(response, 'manufacture')
        })
        Item.loadNorm(str).then(response => {
          this.dealSelect(response, 'norm')
        })
        Item.loadShops(str).then(response => {
          this.dealSelect(response, 'shop')
        })
        Item.loadRegions('联盟类型').then(response => {
          this.dealSelect(response, 'region')
        })
      } else {
        return
      }
    },
    initialData () {
      this.check = true
      this.sortBy = { sorttext: '默认', sort: 'createTime desc' }
      this.showshopName = { shopText: '全部', shopId: -1 }
      this.manuToSearch = { manuText: '全部', search: '' }
      this.normToSearch = { normText: '全部', search: '' }
      this.regionToSearch = { regionText: '全部', unionId: -1 }
      this.pageInfo = { count: '', index: 1, pages: '', size: 10 }
      this.itemList = []
      this.queryHasInventory = -1
      this.selected.forEach((select, index) => {
        select.showSelect.desc = '全部'
        select.disabled = true
      })
    },
    choose (str, data) {
      if (str !== 'sort') {
        this.selected.map((select, index) => {
          if (select.label === str) {
            console.log(select, 'selcet')
            select.showSelect.desc = data.desc
            select.showSelect.search = data.search
            if (index === 0) {
              ({ desc: this.showshopName.shopText, search: this.showshopName.shopId } = data)
            } else if (index === 1) {
              ({ desc: this.manuToSearch.manuText, search: this.manuToSearch.search } = data)
            } else if (index === 2) {
              ({ desc: this.normToSearch.normText, search: this.normToSearch.search } = data)
            } else if (index === 3) {
              ({ desc: this.regionToSearch.regionText, search: this.regionToSearch.unionId } = data)
            }
          }
        })
      } else {
        ({ text: this.sortBy.sorttext, sort: this.sortBy.sort } = data)
      }
      this.pageInfo.index = 1
      this.searchFirst()
    },
    dealSelect (data, str) {
      this.selected.forEach((select, index) => {
        if (select.label === str) {
          select.selectArray.length = 1
          data.forEach(region => {
            if (index === 1 || index === 2) {
              const regions = { desc: region, search: region }
              select.selectArray.push(regions)
            } else {
              const regions = { desc: region.name, search: region.id }
              select.selectArray.push(regions)
            }
          })
          if (select.selectArray.length > 1) select.disabled = false
        }
      })
      console.log(this.selected, 'se')
    },
    dealItems (data) {
      const Item = new ItemService(this.$axios)
      this.itemList = []
      const { items = [], pageInfo = {}} = data;
      ({ count: this.pageInfo.count, index: this.pageInfo.index, pages: this.pageInfo.pages, size: this.pageInfo.size } = pageInfo)
      items.forEach(item => {
        this.itemList.push(item)
      })
      const itemIds = items.map((item) => { return item.id })
      Item.loadFullInfo(itemIds).then((res) => {
        this.handleItems(res)
      })
    },
    dealPromotion (item) {
      var promotion = item.promotion
      var content = ''
      var str = promotion.disType === 1 ? '元' : item.basicUnit
      if (item.promotionType === 1) {
        item.promotion.gradsRules.forEach(ruleInfo => {
          console.log(ruleInfo, 'rule')
          content += `<p>购买 ${item.commonName} 满${ruleInfo.amount}${str} 送${ruleInfo.giftName} X${ruleInfo.giftNumber}</p>`
        })
      } else if (item.promotionType === 2) {
        content += `<strong>活动价：￥${promotion.activePrice}</strong> 活动起订量：${promotion.least}${item.basicUnit} 活动限购 ${promotion.limitNum}${item.basicUnit}，超出数量按原价购买</p>`
      }
      return content
    },
    handleItems (items) {
      const itemMap = new Map()
      items.forEach(item => {
        itemMap.set(item.id, item)
      })
      this.itemList.forEach(item => {
        let promotion = ''
        if (item.id === itemMap.get(item.id).id) {
          item.image = itemMap.get(item.id).image
          item.promotionType = itemMap.get(item.id).promotionType
          if (item.promotionType !== -1) {
            promotion = this.dealPromotion(itemMap.get(item.id))
          }
          item.promotion = promotion
          item.inventory = itemMap.get(item.id).inventory
          item.expiryTime = itemMap.get(item.id).expiryTime
          item.disabled = itemMap.get(item.id).disabled
          item.oldPrice = itemMap.get(item.id).instructPrice.toFixed(2)
          item.showPrice = itemMap.get(item.id).promotion.activePrice || itemMap.get(item.id).showPrice
          item.showPrice = item.showPrice.toFixed(2)
        }
      })
      console.log(this.itemList, 'litemlsllalga')
    }
  }
}
</script>
<style>
  #about-goods {
    max-width: 1200px;
    text-align: center;
    margin: 0 auto;
    color: #000;
    padding-bottom: 200px;
  }
  #about-goods a {
    color:#000;
    text-decoration: none;
  }
  .show-alert {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 300px;
  }
  #header{
    height: 60px;
    padding: 15px 15px 0 15px;
  }
  #about-goods .select-text {
    position: relative;
    display: inline-block;
    width: 73.3%;
  }
  #about-goods .btn-group {
    width: 100%;
  }
  #about-goods .btn {
    text-align: left;
    background-color: #fff;
    padding: 0 0.625rem;
    overflow: hidden;
    height: 30px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  #about-goods .btn-outline-danger{
    color: #000;
    font-weight: normal;
  }
  .row {
    margin: 0;
    justify-content:space-between;
  }
  #about-goods .col:first-child {
    text-align: left;
  }
  #about-goods .col {
    padding: 0;
    height: 30px;
    line-height: 1.2;
    text-align: right;
    font-weight: normal;
    font-size: 1rem;
  }
  .m-1 {
    margin: 0 !important
  }
  .btn-outline-danger {
    color: #000;
    border-color: #ccc;
  }
  #about-goods .btn-outline-danger:focus, #about-goods .btn-outline-danger.focus {
    box-shadow: 0 0 0 0 transparent;
  }
  #about-goods .btn-outline-danger:hover {
    border-color: #ccc;
  }
   .dropdown-menu {
    height: 10rem;
    min-width: 15rem;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    transform: translate3d(0px, 0px, 0px) !important;
    margin-top: 30px;
  }
  .dropdown-item {
    padding-left: 0.5rem;
  }
  .dropdown-toggle::after {
    position: absolute;
    top: 0.65rem;
    right: 0.75rem;
    color: #ccc;
    border-top: 0.5em solid;
    border-right: 0.5em solid transparent;
    border-left: 0.5em solid transparent;
  }
  #about-goods .outline-danger.dropdown-toggle {
    border: 0;
  }
  #sort-by {
    height: 40px;
    margin-top: 10px;
    text-align: left;
    display: flex;
    background-color: #e3e4e5;
    line-height: 40px;
    padding: 0 10px;
  }
  #sort-by .sort {
    margin-right: 1.75rem;
    width: 25.4%;
  }
  .search-box {
    position: absolute;
    top: 0;
  }
  #content {
    background-color: #fff;
    margin-top: 24px;
  }
  #content .table tbody th,
  #content .table tbody td {
    border-bottom: 1px dashed #000;
    border-top: 0;
    padding: 0;
    text-align: center;
    vertical-align: middle;
    font-size: 0.75rem;
  }
  #content .table thead td,
  #content .table thead th {
    border: 0;
    padding: 0;
    height: 30px;
    line-height: 1.5;
    font-size: 0.875rem;
    font-weight: normal;
    background-color: #e3e4e5;
  }
  #content .table thead th {
    vertical-align: middle;
  }
  #content .table tr td:nth-child(1) {
    width: 70px;
  }
  #content .table tr td:nth-child(2) {
    width: 150px;
    position:relative;
  }
  #content .table tr td:nth-child(3) {
    width: 70px;
  }
  #content .table tr td:nth-child(4) {
    width: 120px;
  }
  #content .table tr td:nth-child(5) {
    width: 110px;
  }
  #content .table tr td:nth-child(6) {
    width: 120px;
  }
  #content .table tr td:nth-child(7) {
    width: 50px;
  }
  #content .table tr td:nth-child(8) {
    width: 40px;
  }
  #content .table tr td:nth-child(9) {
    width: 75px;
  }
  #content .table tr td:nth-child(10) {
    width: 80px;
  }
  #content .table tr td:nth-child(11) {
    width: 65px;
  }
  #content .table tr td:nth-child(12) {
    width: 65px;
    position: relative;
  }
  #content .table tr td:nth-child(13) {
    width: 125px;
  }
  #content .table tr td:nth-child(14) {
    width: 60px;
  }
  #content td .active-type {
    display: inline-block;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 25%;
    left: -10%;
    color: #fff;
    background-color: #f00;
  }
  #content td .item-number {
    width: 108px;
    height: 20px;
    box-sizing: border-box;
    margin: 0 auto;
  }
  #content td .num {
    width: 66px;
    height: 100%;
    padding: 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    text-align: center;
    outline: 0;
    border-right: 0;
    border-left: 0;
    vertical-align: top;
  }
  #content td .num:disabled {
    background-color: #f5f5f5;
  }
  #content td .cutdown,
  #content td .add {
    width: 20px;
    height: 100%;
    border: 1px solid #ccc;
    box-sizing: border-box;
    text-align: center;
    line-height: 16px;
    display: inline-block;
    vertical-align: top;
    cursor:pointer;
  }
  #content img {
    max-width: 30px;
  }
  #content .btn-danger {
    width: 56px;
    height: 20px;
    background-color: #e62129;
  }
  #content .btn {
    font-size: 0.75rem;
    border-radius: 0.2rem;
    text-align: center;
  }
  #content .table tbody tr td:nth-child(14) {
    text-align: right;
  }

</style>
